import type { AxiosResponse } from "axios";
import { api } from "../axiosInstance";
import { getBaseUrl } from "../api";

const ENDPOINTS = {
  create: `${getBaseUrl()}/manual-transactions`,
  update: `${getBaseUrl()}/manual-transactions`,
  promote: `${getBaseUrl()}/recon/promote-to-matched`,
  getAllTxn: `${getBaseUrl()}/manual-transactions`,
  searchRules: `${getBaseUrl()}/matching-rules/search`,
  getInvestigatedIds: `${getBaseUrl()}/reconciliations/all-manual`,
};

// export async function getMatchRuleById(ruleId: number): Promise<any> {
//   const resp: AxiosResponse = await api.get(
//     `${ENDPOINTS.getRuleById}/${ruleId}`
//   );
//   return resp.data;
// }

export async function getInvestigatedTxnIds(): Promise<any> {
  const resp: AxiosResponse = await api.get(
    `${ENDPOINTS.getInvestigatedIds}`
  );
  return resp.data;
}

// export async function getMatchRuleById(ruleId: number): Promise<any> {
//   const resp: AxiosResponse = await api.get(
//     `${ENDPOINTS.getRuleById}/${ruleId}`
//   );
//   const conditions = JSON.parse(resp.data.conditions);
//   return {
//     channel: resp.data.channel?.channel_name ?? null,
//     source: conditions?.sources ?? [],
//     matchingType: conditions?.matching_type
//       ? conditions.matching_type.split("-")[0]
//       : null,
//   };
// }
export async function getMatchRuleByChannel(channelId: number): Promise<any> {
  const resp: AxiosResponse = await api.get(
    `${ENDPOINTS.searchRules}?channel_id=${channelId}`
  );

  const rule = resp.data?.[0]; // take first match

  if (!rule?.conditions) {
    return {
      channel: null,
      source: [],
      matchingType: null,
    };
  }

  const conditions = JSON.parse(rule.conditions);

  return {
    channel: rule.channel?.channel_name ?? null,
    source: conditions.sources ?? [],
    matchingType: conditions.matching_type
      ? conditions.matching_type.split("-")[0]
      : null,
  };
}

// export async function getAllItems(): Promise<any> {
//   const resp: AxiosResponse = await api.get(ENDPOINTS.getAllTxn)
//   return resp.data;
// }
export async function getAllItems(userId?: number): Promise<any> {
  const resp: AxiosResponse = await api.get(ENDPOINTS.getAllTxn, {
    params: { user_id: userId },
  });
  return resp.data;
}
 
export async function createManualTransaction(payload: any): Promise<any> {
  const resp: AxiosResponse = await api.post(ENDPOINTS.create, payload);
  return resp.data;
}

// export async function patchManualTransaction(
//   ids: number[],
//   payload: any
// ): Promise<any> {
//   const resp: AxiosResponse = await api.patch(
//     `${ENDPOINTS.update}/${ids}`,
//     payload
//   );
//   return resp.data;
// }
export async function patchManualTransaction(payload: {
  manual_txn_ids: number[];
  reconciliation_status: number;
  comment?: string;
   patch_type: string,
}): Promise<any> {
  const resp: AxiosResponse = await api.patch(
    ENDPOINTS.update,  
    payload
  );

  return resp.data;
}


export async function promoteReconTransaction(
  reconReferenceNumber: string,
  rrn: string
): Promise<any> {
  const resp = await api.patch(
    `${ENDPOINTS.promote}`,
    {
      recon_reference_number: reconReferenceNumber,
      rrn,
    }
  );
  return resp.data;
}
